/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Networks, EntityTypes, AdWordsStatusMap } from 'AdsUI/lib/Constants';
import AdAccountRecord from 'AdsUI/records/ad-accounts/AdAccountRecord';
import ReportingCampaignRecord from 'AdsUI/records/reporting/ReportingCampaignRecord';
import KeywordModalContainer from './add-entity/KeywordModalContainer';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ScopeWrapper from 'AdsUI/components/ScopeWrapper';
const IMPLEMENTED_ENTITY_TYPES = [EntityTypes.KEYWORD];
const MODAL_BY_TYPE = {
  [EntityTypes.KEYWORD]: KeywordModalContainer
};

const AddEntityContainer = ({
  network,
  adAccount,
  parent,
  campaignEntity,
  entityType
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  if (network !== Networks.ADWORDS) {
    return null;
  }

  if (!campaignEntity) {
    return null;
  }

  if (entityType === EntityTypes.NEGATIVE_KEYWORD) {
    return null;
  }

  if ((entityType === EntityTypes.AD || entityType === EntityTypes.KEYWORD) && parent && parent.status !== AdWordsStatusMap.ENABLED && parent.status !== AdWordsStatusMap.PAUSED) {
    return null;
  }

  if (IMPLEMENTED_ENTITY_TYPES.indexOf(entityType) > -1) {
    const ModalContainer = MODAL_BY_TYPE[entityType];
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ScopeWrapper, {
        tooltipKey: "performThisAction",
        children: /*#__PURE__*/_jsx(UIButton, {
          size: "small",
          use: "tertiary-light",
          onClick: () => setModalOpen(true),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `campaigns.management.addEntity.types.ADWORDS.${entityType}`
          })
        })
      }), modalOpen && /*#__PURE__*/_jsx(ModalContainer, {
        network: network,
        adAccount: adAccount,
        parent: parent,
        campaignEntity: campaignEntity,
        onClose: () => setModalOpen(false)
      })]
    });
  }

  return null;
};

AddEntityContainer.propTypes = {
  network: PropTypes.oneOf(Object.values(Networks)).isRequired,
  adAccount: PropTypes.instanceOf(AdAccountRecord).isRequired,
  campaignEntity: PropTypes.instanceOf(ReportingCampaignRecord),
  entityType: PropTypes.oneOf(Object.values(EntityTypes)).isRequired
};
export default AddEntityContainer;